import './App.css';
import { Provider } from 'react-redux';
import store from './store';
import {Navigate, Outlet, Route, Routes, useNavigate} from 'react-router-dom';
import NotFound from './components/NotFound/NotFound';
import Layout from './components/Layout/Layout';
import Main from './pages/Main/Main';
import AboutCompany from './pages/AboutCompany/AboutCompany';
import Signin from './pages/Signin/Signin';
import Signup from './pages/Signup/Signup';
import Forget from './pages/Signin/Forget';
import AboutCourse from './pages/AboutCourse/AboutCourse';
import Profile from './pages/Profile/Profile';
import PassingCourse from './pages/PassingCourse/PassingCourse';
import Certification from "./pages/Certification/Certification";
import {Terms} from "./pages/Terms/Terms";
import Policy from './pages/Policy/Policy';

const App = () => {
  return (
      <Provider store={store}>
        <div className="App">

          <Routes>
            <Route path='/' element={<Layout />}>
              <Route index element={<Main />} />
              <Route path='privacy_policy' element={<Policy />} />
              <Route path='aboutoaa' element={<AboutCompany />} />
              <Route path='signup' element={<Signup />} />
              <Route path='signin' element={<Signin />} />
              <Route path='certification' element={<Certification />} />
              <Route path='forget' element={<Forget />} />
              <Route path='aboutthecourse' element={<AboutCourse />} />
              <Route path='profile' element={<Profile />} />
              <Route path='terms' element={<Terms />} />
              <Route path="passingcourse/:id" element={<PassingCourse />} />
              <Route path='*' element={<NotFound />} />
            </Route>
          </Routes>
        </div>
      </Provider>

  );
}

export default App;
